import { pluralize } from "@shared/svelte/Modules/pluralize";

export const getOrderContainerCounts = products => {
  const counts = {};
  products.forEach(product => {
    if (product.deleted) return;
    if (product.requested_item) return;
    if (product.case_quantity > 0) {
      counts["case"] = (counts["case"] || 0) + product.case_quantity;
    }

    if (product.unit_quantity > 0) {
      counts[product.product.container_type] =
        (counts[product.product.container_type] || 0) + product.unit_quantity;
    }
  });
  return counts;
};

export const getCartContainerCount = cart => {
  let counts = {};
  cart.orders.forEach(order => {
    if (!order.distributor.ordering_disabled) {
      let orderCount = getOrderContainerCounts(order.products);
      for (const container in orderCount) {
        counts[container] = (counts[container] || 0) + orderCount[container];
      }
    }
  });
  return counts;
};

export const getContainerCountString = counts => {
  let display = [];
  Object.keys(counts)
    .sort()
    .forEach(container => {
      display.push(pluralize(container, counts[container], true));
    });
  return display.join(", ");
};
